import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useBusinessMypageMain } from "~/services/business/myPage";
import a1 from "$/a1.svg";
// import informSrc from "$/inform.svg";
// import { ThemedAnchor } from "@/Anchor";
import { IconSchool } from "@/Icon/School";
import { IconBath } from "@/Icon/Bath";
import { IconFoot } from "@/Icon/Foot";
import { IconHotelBuilding } from "@/Icon/HotelBuilding";
import { IconSchoolBuilding } from "@/Icon/SchoolBuilding";
import { IconDogB } from "@/Icon/DogB";
import { IconDogT } from "@/Icon/DogT";
import { IconHairShop2 } from "@/Icon/HairShop2";
// import { useAppExit } from "^/common/useAppExit";
// import { AppExitDialog } from "@/AppExitDialog";
// import { BusinessType } from "#/unique/domain";
// import { useStorage } from "^/common/useStorage";
// {active ? "#FF9934" : "#999999"}
// const services = [
//   { label: "유치원", icon: <IconSchoolBuilding active={true} />, active: true },
//   { label: "데이케어", icon: <IconFoot active={true} />, active: true },
//   { label: "호텔링", icon: <IconHotelBuilding active={true} />, active: true },
//   { label: "펫택시", icon: <IconSchool active={false} />, active: false },
//   { label: "미용", icon: <IconHairShop2 active={false} />, active: false },
//   { label: "목욕", icon: <IconBath active={true} />, active: true },
//   { label: "행동교정", icon: <IconDogB active={false} />, active: false },
//   { label: "전문훈련", icon: <IconDogT active={false} />, active: false },
// ];

export const Route = createFileRoute("/business/layout/user")({
  component: User,
});

function User() {
  const { history } = useRouter();
  const { data: mypageMain } = useBusinessMypageMain();

  // const { showExitDialog, hideExitConfirmation, confirmAppExit } = useAppExit();

  // const [business] = useStorage<BusinessType>("local-business-type");

  const services2 = [
    {
      label: "유치원",
      count: mypageMain?.businessStats?.totalReservations ?? 0,
    },
    {
      label: "데이케어",
      count: mypageMain?.businessStats?.totalReservations ?? 0,
    },
    {
      label: "호텔링",
      count: mypageMain?.businessStats?.totalReservations ?? 0,
    },
    { label: "미용", count: mypageMain?.businessStats?.totalReservations ?? 0 },
  ];

  const serviceIcon = (service: string, active: boolean) => {
    switch (service) {
      case "유치원":
        return <IconSchoolBuilding active={active} />;
      case "데이케어":
        return <IconFoot active={active} />;
      case "호텔링":
        return <IconHotelBuilding active={active} />;
      case "펫택시":
        return <IconSchool active={active} />;
      case "미용":
        return <IconHairShop2 active={active} />;
      case "목욕":
        return <IconBath active={active} />;
      case "행동교정":
        return <IconDogB active={active} />;
      case "전문훈련":
        return <IconDogT active={active} />;
      case "어질리티":
        return <IconDogT active={active} />;
      case "셀프목욕":
        return <IconBath active={active} />;
      default:
        return <IconSchoolBuilding active={true} />;
    }
  };
  return (
    <div className="flex-1 min-h-0 overflow-y-auto px-3 pt-5 bg-[#F5F5F5]">
      <div className="bg-[#F5F5F5]">
        <div className="flex justify-between px-1">
          <div className="font-medium text-[18px]">
            {mypageMain?.companyName ?? "고객" + " "} 현황
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => {
                // if (business === "business-teacher") {
                //   history.push("/business/layout/user-teacher-setting");
                // } else {
                history.push("/business/layout/user-owner-setting");
                // }
              }}
              className="text-gray-600"
            >
              설정
            </button>
          </div>
        </div>
        <div className="mt-4">
          <div className="flex items-center bg-white border-[1px] border-gray-200 rounded-xl h-[114px]">
            <img
              src={mypageMain?.fileUrl ?? a1}
              alt="유치원 이미지"
              className="mx-5 my-2 rounded-full w-[80px] h-[80px] bg-gray-50"
            />
            <div className="flex flex-col gap-2 ml-2 text-left">
              <p className={"text-base font-bold"}>
                {mypageMain?.companyName ?? "고객"}
              </p>
              <p className="text-sm text-[##666666]">
                원장: {mypageMain?.bizUserName ?? "고객"}
              </p>
            </div>
          </div>
        </div>
        {/* {mypageMain?.noticeMessage && (
          <div className="mt-4">
            <ThemedAnchor
              to="/business/layout/user-owner-setting"
              color="secondary"
              className="flex gap-2 items-center px-4 mb-2 text-sm text-black bg-white rounded-lg"
            >
              <img src={informSrc} alt="알림장" />
              {mypageMain?.noticeMessage}
            </ThemedAnchor>
          </div>
        )} */}
        <div className="mt-4">
          <div className="mb-2 font-medium">
            {mypageMain?.companyName ?? "고객"} 님은 현재 이렇게 서비스를
            제공해요
          </div>
          <div className="grid grid-cols-4 gap-3">
            {mypageMain?.serviceProvides?.map((service) => (
              <div
                key={service.provideSeq}
                className="flex flex-col items-center justify-center bg-white rounded-md shadow-sm border-[1px]
                border-[#E9E9E9] aspect-square"
                style={{
                  borderColor: service.activeYn === "Y" ? "#FF9934" : "#E9E9E9",
                }}
              >
                <div className="flex justify-center items-center w-10 h-10">
                  {serviceIcon(service.provideName, service.activeYn === "Y")}
                </div>
                <p
                  className="text-[14px] font-medium"
                  style={{
                    color: service.activeYn === "Y" ? "#FF9934" : "#666666",
                  }}
                >
                  {service.provideName}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-5">
          <div className="mb-2 font-medium">
            이번달의 서비스 이용고객 현황이예요.
          </div>
          <div className="grid grid-cols-4 gap-3">
            {services2.map((service) => (
              <div
                key={service.label}
                className="flex flex-col items-center justify-center bg-white rounded-md shadow-sm border-[1px]
                border-[#E9E9E9] aspect-square"
              >
                <div className="flex flex-col gap-1 justify-center items-center">
                  <p className="text-[14px] text-[#666666] font-normal">
                    {service.label}
                  </p>
                  <p className="text-[16px] font-semibold">{service.count}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-5">
          <div className="mb-2 font-medium">
            이용 현황의 기준은 다음과 같아요
          </div>
          <div>
            <div className="flex gap-2 items-center mb-2 font-normal">
              <div className="w-1 h-1 bg-[#666666] rounded-full"></div>
              <div className="text-[#666666] text-[13px]">
                보호자가 아닌 반려동물의 수로 집계해요.
              </div>
            </div>
            <div className="flex gap-2 items-center mb-2 font-normal">
              <div className="w-1 h-1 bg-[#666666] rounded-full"></div>
              <div className="text-[#666666] text-[13px]">
                각 서비스 별로 중복 집계되어요.
              </div>
            </div>
            <div className="flex gap-2 items-center mb-2 font-normal">
              <div className="w-1 h-1 bg-[#666666] rounded-full"></div>
              <div className="text-[#666666] text-[13px]">
                서비스 집계 기준은 매 월 리셋돼요.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <AppExitDialog
        visible={showExitDialog}
        onConfirm={confirmAppExit}
        onCancel={hideExitConfirmation}
      /> */}
    </div>
  );
}
